import { render, staticRenderFns } from "./CourseCard.vue?vue&type=template&id=4b6e80d6&scoped=true"
import script from "./CourseCard.vue?vue&type=script&lang=ts"
export * from "./CourseCard.vue?vue&type=script&lang=ts"
import style0 from "./CourseCard.vue?vue&type=style&index=0&id=4b6e80d6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6e80d6",
  null
  
)

export default component.exports